import { render, staticRenderFns } from "./label-payment-state.vue?vue&type=template&id=58cb5bfe&"
import script from "./label-payment-state.vue.ts?vue&type=script&lang=ts&"
export * from "./label-payment-state.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports